import { NodeModel } from "../_model/NodeModel";
import { DecorationOccupation } from "./decorationOccupation"
import { Types } from "../../utils/nodeTypes"
import Properties from "../_model/ModelEngineeringProperties";

class Occupation extends NodeModel {
  constructor() {
    super("Occupation");
    
    this.type = new Types().Occupation;
    this.title = "Occupation";
    this.x = 0;
    this.y = 0;
    this.minimumOccupation = "30";
    this.maximumOccupation = "100";
    this.textInPixels = 140;
    this.xText = () => this.x + 15;
    this.xTextValue = () => this.xText() + 45 + this.textInPixels;
    this.xCircle = () => this.x;
    this.height = 42;
    this.heightText = (this.height / 2);
    this.heightCircle = (this.height / 2) - 5;
    this.width = 70;
    this.data = [new Properties({...this, height: 0})];
    this.dataType = '';
    
    this.decorate = async function(callback) {
      this.decorator = new DecorationOccupation();
      await this.decorator.init(this, callback)
    };

    this.update = (nodeEdited) => {
      this.dataType = nodeEdited.dataType

      if (nodeEdited.attrs) {
        this.data = nodeEdited.attrs
        this.data.forEach(attr => {
          attr.caption = ''
          attr.unit = ''
          attr.height= 0
        });
      }
      this.maximumOccupation = nodeEdited.maximumOccupation;
      this.minimumOccupation = nodeEdited.minimumOccupation;
      this.textInPixels = nodeEdited.textInPixels;
      this.title = nodeEdited.title;
      let valueLenght = this.data.length > 0 ? this.data[0].value.length : 0;
      let lenghtOfFont = this.title.length > valueLenght ? this.title.length * 9 : valueLenght * 9;
      this.width = lenghtOfFont;
      this.xTextValue = () => this.xText() + 45 + nodeEdited.textInPixels;
      
      this.decorator.setTextAndAdjustCircleColor(this.textInPixels);
    }

    this.clone = function() {
      let cloned = new Occupation();
      cloned.id = this.id;
      cloned.idName = this.idName
      cloned.type = this.type
      cloned.title = this.title
      cloned.textInPixels = this.textInPixels
      cloned.width = this.width
      cloned.x = this.x;
      cloned.minimumOccupation = this.minimumOccupation;
      cloned.maximumOccupation = this.maximumOccupation;
      cloned.y = this.y;
      cloned.dataType = this.dataType 
      cloned.readOnly = this.readOnly;
      cloned.expressionVisible = this.expressionVisible
      cloned.data = this.data.map(d => d.clone());

      return cloned;
    }

    this.copyFrom = (node) =>{
      this.simpleCopyFrom(node)
      this.title = node.title
      this.maximumOccupation = node.maximumOccupation
      this.minimumOccupation = node.minimumOccupation
      this.textInPixels = node.textInPixels
      this.dataType = node.dataType
      this.data = node.data.map(d => new Properties({...d}))
    }

    this.reloadProperties = function(){
      this.update(this)
    }
  }
}


export { Occupation };
